
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from "@material-ui/core/styles/withStyles";


function setItemFontStyles(fontFamily: string,
  fontStyle: string,
  fontWeight: any,
  fontSize: string,
  lineHeight: string,
  color: string): CSSProperties {
  return {
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    fontSize: fontSize,
    lineHeight: lineHeight,
    color: color,
  }
}
export const useStyles:any = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    root:{
      border: "1px solid #E8EAF4",
      borderRadius: "0.625rem",
      marginBottom:"0.938rem",
      '&::before':{
        height:"unset!important"
      }
    },
    error:{
      borderColor:"red!important",
    },
    addLocationBtn:{
      border:"unset",
      color:"#8D98B7!important",
      "& svg":{
        border:"1px solid #8D98B7",
        paddingRight:"0.2rem!important",
        padding:"0.2rem",
        marginRight:"0.313rem",
        borderRadius:"50%"
      }
    },
    locationError:{
      "& .MuiInputLabel-outlined":{
        color:"red!important"
      },
      "& .MuiOutlinedInput-root":{
        borderColor:"red!important"
      }
    },
    wrapper:{
      position:"relative",
      width:"100%",
      display:"flex",
      justifyContent:"space-between",
      alignItems:"center",
      "& > p":{
        ...setItemFontStyles("Open Sans","normal",600,"1rem","1.375rem","#212121"),
        margin:0
      },
      "& > div":{
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center",
        "& > svg":{
            margin:"0.313rem",
            color:"#8D98B7"
        }
      }
    },
    modalContainer: {
      "& .MuiDialog-paperWidthMd": {
        width: "30rem!important",
        height:"23rem"
      }
    },
    closeBtn:{
      paddingTop:"12px!important",
      marginTop:"20px"
    },
    alert:{
      margin:"1.25rem 0",
      width:"80%"
    },
    disabled:{
      color:"#C1CAE1!important"
    },
    formSwitchContainer:{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      '&>span':{
        float:'unset'
      }
    }
  }),
);